import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../utils/api';
import { LearningStats, LearningTrack, LearningTrackInput } from '../types';

export const useLearningStats = () =>
  useQuery({
    queryKey: ['learning', 'stats', 'me'],
    queryFn: async (): Promise<LearningStats> => api('/learning/me/stats'),
    staleTime: 30_000,
  });

export const useLearningTracks = () =>
  useQuery({
    queryKey: ['learning', 'tracks'],
    queryFn: async (): Promise<LearningTrack[]> => api('/learning/tracks'),
    staleTime: 30_000,
  });

export const useCreateLearningTrack = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: LearningTrackInput) =>
      api('/learning/tracks', { method: 'POST', body: data }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['learning', 'tracks'] }),
  });
};

export const useUpdateLearningTrack = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<LearningTrackInput> }) =>
      api(`/learning/tracks/${id}`, { method: 'PUT', body: data }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['learning', 'tracks'] }),
  });
};

export const useDeleteLearningTrack = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api(`/learning/tracks/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['learning', 'tracks'] }),
  });
};
